import { formatDate } from '../../utils';

const transformOrganizationData = ({ results = [] }) =>
  results.map(({ id, name, displayName, description, status, createdAt }) => ({
    id,
    name,
    displayName,
    description,
    status,
    createdOn: formatDate(createdAt),
  }));

export default transformOrganizationData;
